const ASYNC_QUEUE_STATUSES = {
	PENDING: 'pending',
	IN_PROGRESS: 'in-progress',
	FULFILLED: 'fulfilled',
	REJECTED: 'rejected',
}

Object.freeze(ASYNC_QUEUE_STATUSES)

export {
	ASYNC_QUEUE_STATUSES,
}
